module.exports = __webpack_public_path__ + "media/images/area/area_toyamaM400-6a154cc3f71099d4e9f82ee5083204ed.jpg";